// scroll the page smoothly to certain element
function scrollTo(element, complFunc) {
    var hasStickyHeader = $('body').hasClass('posifixed');
    var stickyHeaderOffset = hasStickyHeader ? $('header').outerHeight() : 0;

    var position = $(element).offset().top - stickyHeaderOffset;
    var options = {
        scrollTop: position
    };
    $('html, body').animate(options, 700, complFunc);
}